import { css } from 'emotion';

export namespace styles {
  export const headerActionRules = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  });

  export const chevronContainerRules = css({
    padding: 5,
    cursor: 'pointer'
  });

  export const chevronRules = (direction: 'left' | 'right') => {
    return css({
      '::before': {
        borderStyle: 'solid',
        borderWidth: '3px 3px 0 0',
        content: `''`,
        display: 'inline-block',
        height: 8,
        left: 0,
        position: 'relative',
        transform: `rotate(${direction === 'left' ? -135 : 45}deg)`,
        width: 8
      }
    });
  };

  export const todayRules = css({
    cursor: 'pointer',
    textTransform: 'uppercase',
    fontSize: 12,
    height: 20,
    letterSpacing: '.4px',
    lineHeight: '20px',
    fontWeight: 800
  });
}
